import { Injectable } from "@angular/core";
import { InspectionListItem } from "../../_objects/inspection";
import { User } from "../../_objects/user";
import { NetworkStatusService } from "../network-status.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";

@Injectable()
export class SharedLockService {
  private currentUser: User;

  constructor(private loginUserOfflineService: LoginUserOfflineService, private networkStatusService: NetworkStatusService) {
    if (this.networkStatusService.isDesktop()) {
      this.currentUser = this.loginUserOfflineService.loginUser;
    }
  }

  private get isOffline() {
    return this.networkStatusService.isOffline;
  }

  isReportLocked(inspection: InspectionListItem) {
    const isLocked = !!inspection.sharedLockBy;
    return this.isOffline ? false : isLocked;
  }

  isInspectionLocked(inspection: InspectionListItem) {
    return this.isOffline ? false : inspection.sharedLockBy;
  }

  isLockedByCurrentUser(inspection: InspectionListItem) {
    return inspection?.sharedLockBy?.toLowerCase() && inspection?.sharedLockBy?.toLowerCase() === this.currentUser?.id.toLowerCase();
  }

}
